webpackJsonp([3],{

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_vue__ = __webpack_require__(345);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5496ed7f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Info_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5496ed7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5496ed7f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Mapa__ = __webpack_require__(365);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { EventBus } from '../../core/event-bus.js'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProyectoInfo',
  components: {
    MapaProyecto: __WEBPACK_IMPORTED_MODULE_3__Mapa__["a" /* default */]
  },
  props: ['codigo_proyecto'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getNombreRolPorCodigo'])),
  data: function data() {
    return {
      data: null,
      error: null,
      loading: true
    };
  },
  mounted: function mounted() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getProyectoInfo(this.codigo_proyecto).then(function (data) {
      vm.data = data;
      vm.loading = false;
    }, function (error) {
      vm.error = error.message;
      vm.loading = false;
    });
  }
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MapaProyecto',
  props: ['zoom', 'lat', 'lng'],
  data: function data() {
    return {
      mapOptions: {},
      center: {},
      mapZoom: 12,
      marker: []
    };
  },
  mounted: function mounted() {
    if (this.zoom) {
      this.mapZoom = this.zoom;
    }

    this.center = {
      lat: this.lat,
      lng: this.lng
    };
  },

  methods: {
    getMapaImagen: function getMapaImagen() {
      return 'https://maps.googleapis.com/maps/api/staticmap?center=' + this.center.lat + ',' + this.center.lng + '&key=AIzaSyCBTWJffAwhvV-8K4kkIRdjK4kjI8yzu1M&zoom=8&scale=false&size=640x400&maptype=roadmap&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff6504%7Clabel:%7C' + this.center.lat + ',' + this.center.lng;
    },
    getMapaLink: function getMapaLink() {
      return 'https://www.google.com/maps/dir//' + this.center.lat + ',' + this.center.lng;
    }
  }
});

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(364);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(198)("e9957648", content, true, {});

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(197)(true);
// imports


// module
exports.push([module.i, "h1#proy-code[data-v-5496ed7f]{margin-top:20}img#proy-img[data-v-5496ed7f]{max-height:80px}table.proy-equipo[data-v-5496ed7f]{border:none}table.proy-equipo tr[data-v-5496ed7f]{height:50px}table.proy-equipo .ico-equipo[data-v-5496ed7f]{color:#333;padding:3px 4px;display:block}table.proy-equipo th[data-v-5496ed7f]{background:#ccc}table.proy-equipo tr[data-v-5496ed7f]:nth-child(odd){background:#ddd}table.proy-equipo td[data-v-5496ed7f]:first-child,table.proy-equipo th[data-v-5496ed7f]:first-child{padding-left:10px}", "", {"version":3,"sources":["D:/laragon/www/sima/simaapp-web/src/components/views/proyectos/Info.vue"],"names":[],"mappings":"AACA,8BACE,aAAe,CAChB,AACD,8BACE,eAAiB,CAClB,AACD,mCACE,WAAa,CACd,AACD,sCACE,WAAa,CACd,AACD,+CACE,WAAW,AACX,gBAAiB,AACjB,aAAe,CAChB,AACD,sCACE,eAAiB,CAClB,AACD,qDACE,eAAiB,CAClB,AACD,oGACE,iBAAmB,CACpB","file":"Info.vue","sourcesContent":["\nh1#proy-code[data-v-5496ed7f] {\n  margin-top: 20;\n}\nimg#proy-img[data-v-5496ed7f] {\n  max-height: 80px;\n}\ntable.proy-equipo[data-v-5496ed7f] {\n  border: none;\n}\ntable.proy-equipo tr[data-v-5496ed7f]{\n  height: 50px;\n}\ntable.proy-equipo .ico-equipo[data-v-5496ed7f]{\n  color:#333;\n  padding: 3px 4px;\n  display: block;\n}\ntable.proy-equipo th[data-v-5496ed7f]{\n  background: #ccc;\n}\ntable.proy-equipo tr[data-v-5496ed7f]:nth-child(odd) {\n  background: #ddd;\n}\ntable.proy-equipo td[data-v-5496ed7f]:first-child, table.proy-equipo th[data-v-5496ed7f]:first-child {\n  padding-left: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mapa_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e309ee7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mapa_vue__ = __webpack_require__(368);
function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e309ee7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mapa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e309ee7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mapa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(367);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(198)("09fd10c3", content, true, {});

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(197)(true);
// imports


// module
exports.push([module.i, ".img-mapa[data-v-e309ee7c]{max-width:100%!important}table.table-lat-lng[data-v-e309ee7c]{border-color:#999}table.table-lat-lng th[data-v-e309ee7c]{background:#ccc;padding:5px}table.table-lat-lng td[data-v-e309ee7c]{padding:5px}table.table-lat-lng tr[data-v-e309ee7c]{height:40px}", "", {"version":3,"sources":["D:/laragon/www/sima/simaapp-web/src/components/views/proyectos/Mapa.vue"],"names":[],"mappings":"AACA,2BACE,wBAA0B,CAC3B,AACD,qCACI,iBAAmB,CACtB,AACD,wCACI,gBAAiB,AACjB,WAAa,CAEhB,AACD,wCACI,WAAa,CAChB,AACD,wCACI,WAAa,CAChB","file":"Mapa.vue","sourcesContent":["\n.img-mapa[data-v-e309ee7c] {\r\n  max-width: 100%!important;\n}\ntable.table-lat-lng[data-v-e309ee7c]{\r\n    border-color: #999;\n}\ntable.table-lat-lng th[data-v-e309ee7c]{\r\n    background: #ccc;\r\n    padding: 5px;\r\n    /*border: 1px solid #ecf0f5;*/\n}\ntable.table-lat-lng td[data-v-e309ee7c]{\r\n    padding: 5px;\n}\ntable.table-lat-lng tr[data-v-e309ee7c]{\r\n    height: 40px;\n}\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('table',{staticClass:"table table-lat-lng"},[_vm._m(0),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.lat))]),_c('td',[_vm._v(_vm._s(_vm.lng))])])])])]),_vm._v(" "),_c('a',{staticClass:"lnk-mapa",attrs:{"href":_vm.getMapaLink(),"target":"_blank"}},[_c('img',{staticClass:"img-mapa",attrs:{"src":_vm.getMapaImagen()}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Latitud")]),_c('th',[_vm._v("Longitud")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('bounce-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),(_vm.data)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"pull-left",attrs:{"id":"proy-code"}},[_vm._v(_vm._s(_vm.codigo_proyecto))]),_vm._v(" "),(_vm.data.logo_imagen)?_c('img',{staticClass:"pull-right",attrs:{"id":"proy-img","src":_vm.data.logo_imagen.url}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.data.nombre_proyecto))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.descripcion_proyecto))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h3',[_vm._v("Equipo")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-condensed proy-equipo"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.data.usuarios),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.getNombreRolPorCodigo(item.role)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nombre))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.apellido))]),_vm._v(" "),_c('td',{staticClass:"hidden-xs"},[_c('a',{staticStyle:{"color":"#333"},attrs:{"href":'mailto:'+item.email}},[_vm._v(_vm._s(item.email))])]),_vm._v(" "),_c('td',{staticClass:"hidden-xs"},[_c('a',{staticStyle:{"color":"#333"},attrs:{"href":'tel:+'+item.tel}},[_vm._v(_vm._s(item.tel))])]),_vm._v(" "),_c('td',{staticClass:"visible-xs"},[(item.email)?_c('a',{staticClass:"ico-equipo",staticStyle:{"color":"#333"},attrs:{"href":'mailto:'+item.email}},[_c('i',{staticClass:"fa fa-envelope"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix visible-xs"}),_vm._v(" "),(item.tel)?_c('a',{staticClass:"ico-equipo",staticStyle:{"color":"#333"},attrs:{"href":'tel:+'+item.tel}},[_c('i',{staticClass:"fa fa-phone"})]):_vm._e()])])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h3',[_vm._v("Ubicación")]),_vm._v(" "),(_vm.data)?_c('mapa-proyecto',{attrs:{"lat":_vm.data.latitud,"lng":_vm.data.longitud}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h1',{staticClass:"pull-left",attrs:{"id":"proy-code"}},[_vm._v(_vm._s(_vm.codigo_proyecto))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-center"},[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"visible-xs visible-sm",staticStyle:{"height":"25%"}},[_vm._v(" ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Rol")]),_c('th',[_vm._v("Nombre")]),_c('th',[_vm._v("Apellido")]),_c('th',{staticClass:"hidden-xs"},[_vm._v("Mail")]),_c('th',{staticClass:"hidden-xs"},[_vm._v("Telefono")]),_c('th',{staticClass:"visible-xs"},[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.93839a7527e7c9f45704.js